// Utility di stampa condivise.
// Apriamo una finestra nuova con HTML "pulito" e usiamo paged.js (ospitato come
// asset statico in /public) per impaginare con header (logo) e footer (data +
// "Pagina X di N") nei margin box CSS, poi window.print().

// Escape del testo inserito nell'HTML di stampa.
export function esc(v) {
  if (v === null || v === undefined) return "";
  return String(v)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

// Formattazione numerica coerente con l'app (it-IT).
export function num(n, { dash = false } = {}) {
  const v = Number(n) || 0;
  if (v === 0 && dash) return "—";
  return v.toLocaleString("it-IT", { maximumFractionDigits: 2 });
}

// Foglio di stile di stampa. I margin box (@top-*, @bottom-*) sono resi da paged.js.
// - @top-left: titolo (running element)   - @top-right: logo (running element)
// - @bottom-left: data stampa              - @bottom-right: "Pagina X di N"
function printCss(stampaData) {
  return `
  * { box-sizing: border-box; }
  @page {
    size: A4 landscape;
    margin: 24mm 12mm 15mm;
    @top-left     { content: element(brandTitle); }
    @top-right    { content: element(brandLogo); }
    @bottom-left  { content: "Stampato il ${stampaData}"; font-size: 10px; color: #666; }
    @bottom-right { content: "Pagina " counter(page) " di " counter(pages); font-size: 10px; color: #666; }
  }
  html, body { margin: 0; }
  body { font-family: Roboto, 'Segoe UI', Arial, sans-serif; color: #212121; }

  .brand-title { position: running(brandTitle); font-size: 16px; font-weight: 700; }
  .brand-logo  { position: running(brandLogo); }
  .brand-logo img { height: 13mm; object-fit: contain; }

  h2 { font-size: 15px; margin: 12px 0 6px; }
  .content table { border-collapse: collapse; width: 100%; margin-bottom: 14px; font-size: 12px; }
  .content thead { display: table-header-group; }   /* intestazione ripetuta a ogni pagina */
  .content tr { break-inside: avoid; page-break-inside: avoid; }   /* niente righe spezzate → header ripetuto */
  .content th, .content td { border: 1px solid #999; padding: 4px 6px; text-align: center; }
  .content th { background: #ECEFF1; font-weight: 700; }
  .content td.lbl, .content th.lbl { text-align: left; font-weight: 600; white-space: nowrap; }
  .content small { color: #777; }
  .content .tot { background: #E3F2FD; color: #1565C0; font-weight: 700; }
  .content .block { break-inside: avoid; }   /* blocchi piccoli (card container) */
  .content .neg { color: #2E7D32; }
  .content .err { color: #B71C1C; }
  .content tr.totrow td { background: #F0F4F8; font-weight: 700; }
  .content tr.totrow-first td { border-top: 2px solid #666; }
`;
}

// Apre una finestra di stampa con il body HTML fornito e lancia la stampa.
export function openPrintWindow(titolo, bodyHtml) {
  const w = window.open("", "_blank");
  if (!w) {
    alert("Impossibile aprire la finestra di stampa. Controlla che il browser non blocchi i popup.");
    return;
  }
  const logoUrl = `${window.location.origin}/logo_impj.png`;
  const pagedUrl = `${window.location.origin}/paged.polyfill.js`;
  const stampaData = new Date().toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" });

  const doc = `<!doctype html>
<html lang="it">
<head>
  <meta charset="utf-8" />
  <title>${esc(titolo)}</title>
  <style>${printCss(esc(stampaData))}</style>
</head>
<body>
  <div class="brand-title">${esc(titolo)}</div>
  <div class="brand-logo"><img src="${esc(logoUrl)}" alt="IMAB" onerror="this.style.display='none'" /></div>
  <div class="content">${bodyHtml}</div>
  <script>
    // paged.js: impagina e poi stampa. Fallback: se non si carica, stampa comunque.
    window.PagedConfig = {
      auto: true,
      // Ripete l'intestazione (thead) delle tabelle divise su più pagine:
      // paged.js segna le tabelle-continuazione con data-split-from ma non ne
      // riporta il thead, quindi lo cloniamo noi dalla tabella originale.
      before: function () {
        try {
          class RepeatingTableHeaders extends window.Paged.Handler {
            constructor(chunker, polisher, caller) { super(chunker, polisher, caller); }
            afterPageLayout(pageElement, page, breakToken, chunker) {
              try {
                var tables = pageElement.querySelectorAll('table[data-split-from]');
                for (var i = 0; i < tables.length; i++) {
                  var table = tables[i];
                  var existing = table.querySelector(':scope > thead');
                  if (existing && existing.children.length) continue;
                  var ref = table.getAttribute('data-split-from');
                  var src = (chunker && chunker.source) || document;
                  var sourceTable = src.querySelector('[data-ref="' + ref + '"]');
                  var sourceThead = sourceTable && sourceTable.querySelector(':scope > thead');
                  if (!sourceThead) {
                    var orig = document.querySelector('[data-ref="' + ref + '"]:not([data-split-from])');
                    sourceThead = orig && orig.querySelector(':scope > thead');
                  }
                  if (!sourceThead) continue;
                  if (existing) existing.parentNode.removeChild(existing);
                  table.insertBefore(sourceThead.cloneNode(true), table.firstChild);
                }
              } catch (e) { /* non bloccare l'impaginazione */ }
            }
          }
          window.Paged.registerHandlers(RepeatingTableHeaders);
        } catch (e) { /* se l'handler non si registra, impagina comunque */ }
      },
      after: function () { setTimeout(function () { window.focus(); window.print(); }, 100); }
    };
  </script>
  <script src="${esc(pagedUrl)}" onerror="window.focus(); window.print();"></script>
</body>
</html>`;
  w.document.open();
  w.document.write(doc);
  w.document.close();
}
